import React from 'react'
import Header from '../general/Header';
import SubHeader from '../general/SubHeader';
import Copyright from '../general/Copyright';


const PrivacyPolicy = () => {
  return (
    <>
                  <Header />

<SubHeader message="Privacy Policy" />


<section className='bg-light py-5'>
    <div className='container'>
    <p className='sec-heading my-0 fs-4'>Privacy Policy for KCM Store</p>
    <p className='mt-3 para-text'>At KCM Store, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy explains how we collect, use, and protect your information when you visit and make purchases from our website, https://kcmpharmacy.com (the "Site").

By using our Site and services, you agree to the terms outlined in this Privacy Policy. Please take a moment to read the following details to understand how your personal information is used.</p>

<hr />

<p className='fs-5 fw-semibold'>1. Information We Collect</p>
<p className='para-text'>Name: To process your order and communicate with you regarding your purchase.<br />
Email Address: For order confirmation, customer support, marketing, and promotional communications (if you opt-in).<br />
Phone Number: For communication related to your order, delivery details, or customer service inquiries.<br />
Shipping Address: To deliver your purchased products to the correct address.<br />
Payment Information: Credit card details or payment gateway information necessary for processing your transaction. We do not store your credit card information on our servers; it is processed through a secure third-party payment provider.</p>


<p className='fs-5 fw-semibold'>2. How We Use Your Information</p>
<p className='para-text'>We use the information we collect from you for various purposes, including but not limited to: -<br /><br />
Order Processing and Fulfillment: To process your orders, confirm payment, and deliver the purchased products to your shipping address.<br />
Customer Support: To provide customer service, address inquiries, and resolve any issues with your orders.<br />
Improving Our Services: To analyze website traffic, improve product offerings, enhance user experience, and identify potential issues.</p>

<p className='fs-5 fw-semibold'>3. How We Protect Your Information</p>
<p className='para-text'>We take reasonable steps to safeguard your personal and payment information. Our website uses Secure Socket Layer (SSL) technology to encrypt sensitive data during transactions. Additionally, we store your data securely and follow industry best practices to protect your information from unauthorized access, alteration, or destruction.<br />
However, please note that no online data transmission or storage method is 100% secure. While we strive to protect your personal information, we cannot guarantee its absolute security.</p>

<p className='fs-5 fw-semibold'>4. Your Rights and Choices</p>
<p className='para-text'>You have the following rights regarding your personal information: -<br /><br />
Access: You may request access to the personal information we hold about you.<br />
Correction: You may request that we correct any inaccurate or incomplete personal information.<br />
Deletion: You may request that we delete your personal information, subject to any legal obligations we may have to retain the data.<br />
Cookie Preferences: You can manage your cookie preferences through your browser settings, including blocking cookies or deleting existing ones. Please note that disabling cookies may affect your experience on our Site.</p>

<p className='fs-5 fw-semibold'>5. Refund Policy</p>
<p className='para-text'>At KCM Store, we strive to provide our customers with the highest quality medicines and products. We understand that sometimes issues may arise with your order, and we want to make sure you are satisfied with your purchase.<br /><br />

<strong>Refunds on Expired Medicines: -</strong><br />
If you receive a medicine that is expired or close to expiry, we offer a refund or replacement, provided that the medicine is returned or reported to us within 7 days of receiving the order. To request a refund or replacement for expired medicines, please follow the steps below: -<br /><br />
Contact Us: Fill out our Contact Form or contact our customer service team at newkcm.online@gmail.com with details about your order and the issue with the product.<br />
Provide Evidence: Include the batch number, expiry date, and any other relevant information regarding the expired product.<br />
Approval: After reviewing your claim, our team will process your refund or replacement.<br /><br />

<strong>No Refund Policy (Other Cases):</strong><br />
No Refunds for Non-Expired Products: We do not offer refunds for medicines or other products unless the product is expired or defective upon receipt. Please carefully review your order before confirming the purchase.<br />
No Refunds for Change of Mind: Due to the nature of our products (medicines), we do not accept returns or offer refunds for change of mind. Once the order gets dispatched and shipped, it cannot be canceled unless the product is expired or damaged. You can only Cancel your order till it shows Confirmed.</p>

  <p className='fs-5 fw-semibold'>6. Exchange Policy</p>
          <p className='para-text'>
            We understand that you may occasionally need to exchange a product.<br /><br />
            <strong>Conditions for Exchange:</strong><br />
            - Exchanges are only accepted for defective, damaged, or incorrect products.<br />
            - Requests for exchange must be made within 7 days of receiving the product.<br />
            - The product must be returned in its original packaging with all accessories and documentation.<br /><br />

            <strong>How to Request an Exchange:</strong><br />
            - Request exchange by filling exchange details including the items you want to exchange and add attachments showing the damaged/ defective/ expiry product.<br />
            - Upon approval, we will provide instructions for returning the product and sending the replacement.<br /><br />

          </p>


<p className='fs-5 fw-semibold'>7. Changes to This Privacy Policy</p>
<p className='para-text'>We may update this Privacy Policy from time to time to reflect changes in our practices, technology, or legal requirements. Any updates to this policy will be posted on this page, and the revised policy will become effective immediately upon posting. We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.</p>

<p className='fs-5 fw-semibold'>8. Contact Us</p>
<p className='para-text'>If you have any questions or concerns about this Privacy Policy, your personal information, or our practices, please contact us at: -<br /><br />
KCM Store<br />
Email: newkcm.online@gmail.com<br />
Phone: +91 94382 44971<br />
Address: Khatiyan No- 1166/1165, Mouja-Goilundi, Berhampur, Ganjam, Odisha, 760004<br />
By using our Site, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.</p>


    </div>
</section>

<Copyright />
    </>
  )
}

export default PrivacyPolicy
